import React from 'react';
import { makeStyles } from '@material-ui/core';

import { SdmRichText } from './SdmRichText';

const useStyles = makeStyles(() => ({
  caption: ({ variant, textAlign }) => ({
    '& div[data-contents=true] > div[data-block=true] > div[data-offset-key]': {
      padding: 0,
      marginBottom: 10,
      textAlign: textAlign,
      maxWidht: 800,
      letterSpacing: 0,
      fontWeight: '300',
      ...(variant === 'image' && {
        '@media screen and (min-width: 992px)': {
          fontSize: '16px',
          lineHeight: '18px',
        },
        fontSize: '12px',
        lineHeight: '13px',
      }),
      ...(variant === 'video' && {
        '@media screen and (min-width: 992px)': {
          fontSize: '20px',
          lineHeight: '32px',
        },
        fontSize: '16px',
        lineHeight: '24px',
      }),
      ...(variant === 'cover' && {
        fontSize: '14px',
      }),
    },
    '& div[data-contents=true] > div[data-block=true]:last-of-type > div[data-offset-key]':
      {
        marginBottom: 0,
      },
  }),
}));

export const Caption = ({ text, textAlign, variant = 'image' }) => {
  const classes = useStyles({ textAlign, variant });

  return (
    <SdmRichText
      editorClassName={classes.caption}
      variant="transparent"
      editorStyleOverride={{
        maxHeight: 'none',
        marginRight: 0,
        paddingLeft: 0,
        minHeight: 'none',
      }}
      formControlStyle={{
        margin: 0,
        marginTop: variant === 'image' ? 10 : 0,
      }}
      labelStyle={{
        display: 'none',
      }}
      value={text}
      readOnly
    />
  );
};
